var Operation = /** @class */ (function () {
    function Operation(_httpClient) {
        this._httpClient = _httpClient;
    }
    return Operation;
}());
export default Operation;
